// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./apps/vai_vem/~/slick-carousel/slick/slick.css
// module id = 474
// module chunks = 0